import React, { useMemo } from "react";
import "../bingo.css";
import { makeRowColGrid } from "../helper";

const PreviewLoteria = ({ grid, bingoSize = null, selectedType }) => {
  const modifyGrid = useMemo(() => {
    const checkOnlyImageType = grid?.every((data) => data?.value === "");
    return makeRowColGrid(
      grid,
      bingoSize,
      checkOnlyImageType ? "OnlyImage" : selectedType
    );
  }, [grid]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${modifyGrid.length}, ${
            bingoSize === 5 ? "40px" : bingoSize === 3 ? "67px" : "50px"
          })`,
          borderRadius: "4px",
          overflow: "auto",
        }}
      >
        {modifyGrid?.map((row, rowIndex) =>
          row.map((cell, colIndex) => {
            return (
              <div
                key={`${rowIndex}-${colIndex}`}
                style={{
                  width:
                    bingoSize === 5
                      ? "40px"
                      : bingoSize === 3
                      ? "67px"
                      : "50px",
                  height:
                    bingoSize === 5
                      ? "30px"
                      : bingoSize === 4
                      ? "36px"
                      : bingoSize === 3 && (selectedType === "Image" || selectedType === "OnlyImage")
                      ? "48px"
                      : bingoSize === 4 && (selectedType === "Image" || selectedType === "OnlyImage")
                      ? "48px"
                      : "50px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  overflow: "hidden",
                  backgroundColor: cell.selected
                    ? "#d3f9d8"
                    : cell?.backgroundColor,
                  border: "none",
                  flexDirection: (selectedType === "Image" || selectedType === "OnlyImage") ? "column" : "row",
                  gap: (selectedType === "Image" || selectedType === "OnlyImage") ? "10px" : "0",
                  color: cell.selected ? "black" : "white",
                  cursor: "pointer", // Add cursor pointer to show it's clickable
                  transition: "background-color 0.2s ease", // Smooth transition for selection
                }}
              >
                {selectedType === "Word" || selectedType === "Letter" ? (
                  <span
                    style={{
                      fontSize: "8px",
                    }}
                  >
                    {cell.value}
                  </span>
                ) : (selectedType === "Image" || selectedType === "OnlyImage") ? (
                  <>
                    <img
                      className="grid-cell-image"
                      src={cell.imageUrl}
                      alt=""
                      style={{
                        maxWidth: "50%",
                        maxHeight: "50%",
                        borderRadius: "0px",
                      }}
                    />
                    <div
                      style={{
                        width: "100%",
                        background: "#0b1442",
                        color: "white",
                        fontSize: "8px",
                      }}
                    >
                      {cell.value}
                    </div>
                  </>
                ) : null}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default PreviewLoteria;
